import images from "../images";

const AboutData = {
  PageBanner : {
    SubTitle : "See what's new",
    PageHeading : 'About Us',
    PageParagraph : "Thousands of healthcare providers can benefit from Vaidyo's development of affordable, adaptable, and incredibly useable technology systems to boost productivity, cut expenses, and maximize ROI."
  },
  AboutVadiyo: {
    sideOne: {
      order: "order-1",
      content: {
        Heading: {
          SectionTitle:
            "More than 15 years of experience in resolving challenging healthcare issues.",
          align: "start",
        },
        Text: [
          {
            value:
              "Vaidyo has established a reputation for outstanding provider and client satisfaction.",
          },
          {
            value:
              "Vaidyo LIMS is a fully integrated computer system created for all varieties of medical laboratories.",
          },
          {
            value:
              "The complete automation and extensive feature set of Vaidyo increases productivity, cut expenses, and give any lab a competitive edge.",
          },
        ],
      },
    },
    sideTwo: {
      order: "order-2",
      data: {
        Pics: {
          img: images.application.about1,
          alt: "vaidyo",
        },
      },
    },
  },
  LMSVadiyo: {
    sideOne: {
      order: "order-2",
      content: {
        Heading: {
          SectionTitle: "Vaidyo LIMS",
          align: "start",
        },
        Text: [
            {
            value:
              "Complete order administration, Custom Reports, Smart Notifications, Credit Settlement, thorough MIS Reports, and Analytics are all managed by Vaidyo's Comprehensive Lab Management.  ",
          },
          {
            value:
              "Vaidyo LIMS is a fully integrated computer system created for all varieties of medical laboratories. ",
          },
          {
            value:
              "The complete automation and extensive feature set of Vaidyo increases productivity, cut expenses, and give any lab a competitive edge. ",
          },
        
        ],
      },
    },
    sideTwo: {
      order: "order-1",
      data: {
        Pics: {
          img: images.application.about2,
          alt: "vaidyo",
        },
      },
    },
  },
  VaidyoContent: {
    sideOne: {
      order: "order-2",
      content: {
        Heading: {
          SectionTitle: "Vaidyo Information Technology ",
          align: "start",
        },
        Text: [
          {
            value:
              "Our expertise in the Information Technology coupled with our experience in medical industry enable us to leverage cutting-edge technology to address many of the problems now faced by medical professionals.",
          },
          {
            value:
              "Ideal for practices, labs, and hospitals of any size, including those with many providers, single practitioners, tiny labs, diagnostic centres and regional reference labs. The tried-and-true Vaidyo application package manages all clinical data while streamlining front and back-office administration.",
          }
         
        ],
      },
    },
    sideTwo: {
      order: "order-1",
      data: {
        Pics: {
          img: images.application.about3,
          alt: "vaidyo",
        },
      },
    },
  },
  HMSVadiyo: {
    sideOne: {
      order: "order-1",
      content: {
        Heading: {
          SectionTitle: "Vaidyo HMS",
          align: "start",
        },
        Text: [
          {
            value:
              "The HMS software from Vaidyo focuses on clinical usability with an easy-to-use interface.",
          },
          {
            value:
              "The comprehensive consulting and professional services offered by Vaidyo guarantee that medical practices are making the most of all available resources in order to increase profitability, streamline workflow, relieve the clinical staff from increasing administrative burden, and put the patient back in as the center of attention.  ",
          },
          {
            value:
              "The goal of Vaidyo is to put the patient back in the center of a complex system by offering simple answers. Vaidyo is run by professionals with extensive experience in selecting and integrating EHRs and health IT systems.",
          },
        ],
      },
    },
    sideTwo: {
      order: "order-2",
      data: {
        Pics: {
          img: images.application.about4,
          alt: "vaidyo",
        },
      },
    },
  },

  TeamSection: {
    Heading: {
      SectionTitle: "Every Step of the Way, Our Team Is With You",
      SubHeading:
        "The Vaidyo team's mission is to provide a foundation for close collaboration between Vaidyo and its clients.  ",
      align: "center",
    },
    Cards: [
      {
        id: 1,
        ProfilePic:
          "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/bonnie-green.png",
        FullName: "Bonnie Green",
        Designation: "CEO & Web Developer",
        Quote:
          "Bonnie drives the technical strategy of the flowbite platform and brand.",
        SocialMedia: [
          {
            icon: images.footer.soc1,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc2,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc3,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc4,
            width: "40",
            path: "/",
          },
        ],
      },
      {
        id: 2,
        ProfilePic:
          "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/jese-leos.png",
        FullName: "Jese Avatar",
        Designation: "CTO",
        Quote:
          "Jese drives the technical strategy of the flowbite platform and brand.",
        SocialMedia: [
          {
            icon: images.footer.soc1,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc2,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc3,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc4,
            width: "40",
            path: "/",
          },
        ],
      },
      {
        id: 3,
        ProfilePic:
          "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/michael-gouch.png",
        FullName: "Michael Avatar",
        Designation: "Senior Front-end Developer",
        Quote:
          "Michael drives the technical strategy of the flowbite platform and brand.",
        SocialMedia: [
          {
            icon: images.footer.soc1,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc2,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc3,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc4,
            width: "40",
            path: "/",
          },
        ],
      },
      {
        id: 1,
        ProfilePic:
          "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/sofia-mcguire.png",
        FullName: "Sofia Avatar",
        Designation: "Marketing & Sale",
        Quote:
          "Lana drives the technical strategy of the flowbite platform and brand.",
        SocialMedia: [
          {
            icon: images.footer.soc1,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc2,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc3,
            width: "40",
            path: "/",
          },
          {
            icon: images.footer.soc4,
            width: "40",
            path: "/",
          },
        ],
      },
    ],
  },
};
export default AboutData;
